import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "py-2 ps-2 w-full divide-y divide-blue-200" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "inline-flex me-0 ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$props.titleStyle)
    }, [
      _createElementVNode("small", null, _toDisplayString(_ctx.$props.title), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flex w-full rounded p-2 h-[42dvh] overflow-y-auto", _ctx.$props.shadowStyle || 'c-shadow-gray-1'])
    }, [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "py-2"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("p", null, _toDisplayString(item.title) + ":", 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(item.id) + ": ", 1),
                  _createElementVNode("small", null, _toDisplayString(item.body), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "buttons", {
                  events: {upId: (value)=> _ctx.emitId(item.id, value)}
                })
              ])
            ])
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}